export var clientDpLedgerGetCatogeryDetailsMapper = function (data) {
    if (data && data.length > 0) {
        return data.map(function (item) {
            return {
                DPID: item.dpid,
                DPAcNo: item.dpAcNo,
                FYearValue: item.fYearValue,
                FYear: item.fYear,
                EndDate: item.endDate,
            };
        });
    }
    return [];
};
